<template>
	<!-- 修改密碼 -->
	<el-dialog :close-on-click-modal="false"  :title="$t('model.log')" :visible.sync="logModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">
		<!-- 表單内容 -->
		 <!-- <div class="radio">
		    排序：
		    <el-radio-group v-model="reverse">
		      <el-radio :label="true">倒序</el-radio>
		      <el-radio :label="false">正序</el-radio>
		    </el-radio-group>
		  </div> -->
		  
		  <div style="height: 50vh;overflow-y: auto;" v-loading="loading">
			  <el-timeline :reverse="reverse" >
			    <el-timeline-item
			      v-for="(activity, index) in activities"
			      :key="index"
			      :timestamp="activity.create_time">
			  			<el-tag type="info" v-if="activity.from_type==3" size="mini">{{$t('model.user')}}</el-tag>
			  			  <el-tag v-if="activity.from_type==2" size="mini">{{$t('model.agent')}}</el-tag>
			  			  <el-tag v-if="activity.from_type==0" type="success" size="mini">{{$t('model.system')}}</el-tag>
			  			  <el-tag v-if="activity.from_type==1" type="warning" size="mini">{{$t('model.admin')}}</el-tag>
						  
				  <span class="ml-1 mr-1">{{activity.from_name}} : </span>
			  			  
			      <span>{{activity.title}}</span>
				  
				  <div class="mt-2 pl-5" style="color: #999;font-size: 12px;" v-for="(item,index) in activity.data" :key="index">
					  {{item.name}}
				  </div>
			    </el-timeline-item>
			  </el-timeline>
		  </div>
		
		  
		
		

		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			logModel: {
				type: Boolean,
				default: false
			},
			logType: {
				type: Number,
				default: 1
			},
			isphone: {
				type: Boolean,
				default: false
			},
			logID: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				loading:true,
				reverse: false,
				activities: []
			}
		},
		watch: {
			logModel(newVal) {
				if(newVal){
					this.checkLogData()
				}
			},
		},
		methods: {
			hide(){
				this.$emit('hide')
			},
			
			checkLogData(){
				let url = '/admin/data/checkLogData'
				if(this.logType==2){
					url = '/admin/data/checkzjSerLogData'
				}
				
				this.axios.post(url, {id:this.logID}, {
					token: true
				}).then(res => {
					let all = res.data
					
					if (all.code == 1) {
						this.loading = false
						console.log(all)
						this.activities = all.data.list
						//this.hide()
					}
					
				}).catch(err => {
					
				})
			}
		}
	}
</script>

<style>
	.phone_w{
		width: 90%;;
	}
	.pc_w{
		width: 34%;;
	}
</style>
